import miseAJourRepartitionTva from '@/services/devisCommandes/calcul/miseAJourRepartitionTva';
import * as devisConf from '@/configuration/devisConf';
import calculTva from '@/services/devisCommandes/calcul/calculTva';

export default function calculRepartitionTva(devisCommande, listeLignesCommande, lignesExclues = new Set()) {
  if (!devisCommande) {
    return;
  }
  devisCommande.repartitionsTva = [];
  if (listeLignesCommande) {
    listeLignesCommande.forEach((ligneCommande) => {
      if (ligneCommande.type !== devisConf.NORMAL) return;
      if (devisCommande.type === devisConf.TYPE_DEVIS && lignesExclues.has(ligneCommande)) return;
      miseAJourRepartitionTva(ligneCommande, devisCommande);
    });
  }
  calculTva(devisCommande);
}
